import type {EditorState} from '@codemirror/state'

/** Returns true if there is actual selected text in the editor. */
export function hasNonEmptySelection(state: EditorState): boolean {
  return state.selection.ranges.length === 1 && !state.selection.main.empty
}
